// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WM0p","footer":"styles_footer__2d0Gs"};